import { AddAssetType } from "./AddAssetType";

export enum AssetCategory {
    None = "None",
    Outline = "Outline",
    Manuscript = "Manuscript",
    Handout = "Handout",
    Devotional = "Devotional",
    SmallGroupStudy = "SmallGroupStudy",
    SermonSlides = "SermonSlides",
    Notes = "Notes",
    Audio = "Audio",
    Video = "Video"
}

export function toAssetCategory(assetCategoryValue: string) {
    if(!assetCategoryValue)
        return AssetCategory.None;
        
    let valueNoWhiteSpace = assetCategoryValue.replace(/\s/g, '');
    switch (valueNoWhiteSpace)
    {
        case "None": return AssetCategory.None;
        case "Outline": return AssetCategory.Outline;
        case "Manuscript": return AssetCategory.Manuscript;
        case "Handout": return AssetCategory.Handout;
        case "Devotional": return AssetCategory.Devotional;
        case "SmallGroupStudy": return AssetCategory.SmallGroupStudy;
        case "SermonSlides": return AssetCategory.SermonSlides;
        case "Notes": return AssetCategory.Notes;
        case "Audio": return AssetCategory.Audio;
        case "Video": return AssetCategory.Video;
        default: return AssetCategory.None;
    }
}

export function printAssetCategory(assetCategory: AssetCategory) {
    switch (assetCategory) {
        case AssetCategory.Outline:
            return "Sermon Outline";
        case AssetCategory.Audio:
            return "Sermon Audio";
        case AssetCategory.Devotional:
            return "Devotional";
        case AssetCategory.Handout:
            return "Handout";
        case AssetCategory.Notes:
            return "Notes";
        case AssetCategory.SermonSlides:
            return "Presentation Slides";
        case AssetCategory.SmallGroupStudy:
            return "Small Group Study";
        case AssetCategory.Video:
            return "Sermon Video";
        default:
            return "Sermon Manuscript";
    }
}

export function toAssetCategoryFromNumber(assetCategoryValue: number) {   
    switch (assetCategoryValue)
    {
        case 0: return AssetCategory.None;
        case 1: return AssetCategory.Outline;
        case 2: return AssetCategory.Manuscript;
        case 3: return AssetCategory.Handout;
        case 4: return AssetCategory.Devotional;
        case 5: return AssetCategory.SmallGroupStudy;
        case 6: return AssetCategory.SermonSlides;
        case 7: return AssetCategory.Notes;
        case 8: return AssetCategory.Audio;
        case 9: return AssetCategory.Video;
        default: return AssetCategory.None;
    }
}

export function toAssetAddTypeFromAssetCategoryString(assetCategoryValue: string) {
    let valueNoWhiteSpace = assetCategoryValue.replace(/\s/g, '');
    switch (valueNoWhiteSpace)
    {
        case "Outline": return AddAssetType.SermonOutline;
        case "Manuscript": return AddAssetType.SermonManuscript;
        case "Handout": return AddAssetType.Handout;
        case "Devotional": return AddAssetType.Devotional;
        case "SmallGroupStudy": return AddAssetType.SmallGroupStudy;
        case "SermonSlides": return AddAssetType.PresentationSlides;
        case "Notes": return AddAssetType.Notes;
        case "Audio": return AddAssetType.SermonAudio;
        case "Video": return AddAssetType.SermonVideo;
        default: return AddAssetType.SermonManuscript;
    }
}